import { request } from '../request';
import { CONTENT_ASSET_DURATION_GET } from '../queries';
const cachedDuration = {};
export const getContentAssetDuration = async (contentId, progress) => {
    const isDurationMissing = !progress || !progress.duration;
    let duration = undefined;
    if (isDurationMissing && !cachedDuration[contentId]) {
        const response = await request({
            query: CONTENT_ASSET_DURATION_GET,
            variables: { id: contentId },
        });
        duration = response?.Content?.asset?.duration;
        cachedDuration[contentId] = duration;
    }
    else if (isDurationMissing && cachedDuration[contentId]) {
        duration = cachedDuration[contentId];
    }
    return duration;
};
//# sourceMappingURL=getContentAssetDuration.js.map